export const transformToFormData = (
  data: object,
  formData = new FormData(),
  parentKey = "",
) => {
  for (const [key, value] of Object.entries(data)) {
    const formattedKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File) {
      formData.set(formattedKey, value);
    } else if (value instanceof Array) {
      value.forEach((element: string | Blob) => {
        formData.append(`${formattedKey}[]`, element);
      });
    } else if (value instanceof Object) {
      transformToFormData(value as object, formData, formattedKey);
    } else {
      formData.set(formattedKey, value as string | Blob);
    }
  }
  return formData;
};
